import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Step from '../Step';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.font.primary};
  height: ${rem(106)};
  color: #fff;
  box-sizing: border-box;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

const StepperBox = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: center;
  align-items: center;
  padding-left: ${rem(30)};
  padding-right: ${rem(30)};
  @media (max-width: ${rem(800)}) {
    padding-left: ${rem(20)};
    padding-right: ${rem(20)};
  }
`;

const Line = styled.div`
  margin-bottom: ${rem(10)};
  height: ${rem(25)};
  overflow: hidden;
  margin-left: ${rem(2)};
  position: relative;
  color: ${({ enable }) => (enable ? '#fff' : '#777')};
  @media (max-width: ${rem(1000)}) {
    width: ${rem(100)};
  }
  @media (max-width: ${rem(800)}) {
    width: ${rem(80)};
  }
  @media (max-width: ${rem(600)}) {
    width: ${rem(60)};
  }
`;

class Stepper extends Component {
  render() {
    const steps = [];
    let type = '';
    const { steps: propSteps, className } = this.props;
    propSteps.forEach((step, index) => {
      let indexOf = null;
      propSteps.forEach((step, index) => {
        if (step.value === this.props.selectedStep) {
          indexOf = index;
        }
      });
      if (index < indexOf) type = 'checked';
      else if (index === indexOf) type = 'actual';
      else type = 'next';

      steps.push(
        <Step
          key={index.toString()}
          onClick={() => this.props.onClick(step.value)}
          type={type}
          title={step.title}
        />,
      );
      if (index + 1 !== this.props.steps.length) {
        steps.push(
          <Line enable={type === 'checked'} key={(index + 10).toString()}>
            {'. . . . . . . . . . . . . . . . . . . .'}
          </Line>,
        );
      }
    });

    return (
      <Wrapper className={className}>
        <StepperBox>{steps}</StepperBox>
      </Wrapper>
    );
  }
}

Stepper.propTypes = {
  className: PropTypes.string,
  selectedStep: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
};

Stepper.defaultProps = {
  className: null,
  selectedStep: null,
  steps: [],
  onClick: () => {},
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/components/Stepper/index.js